import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  title: '',
  description: '',
  category: 'good',
  images: [],
  price: '',
  contact: '',
};
